export default __webpack_public_path__ + "static/communication-icon-eff1e96d89938297198b89762603edc7.svg";